import axios from 'axios';
import { environment } from '@environments/environment';

import { MainFilters } from './FiltersTypes';
import { Country, Option } from '@utils/pageConfig/Types';
import { paramsSerializer } from './utils/OverviewServiceUtils';
import { ProductDataType, ProductType } from '@pages/product-analyzer/Product';
import { CollectionDataType } from '@ecosystem/newron-client-collections/build/shared/types';

interface GetFiltersParams {
  clientId: number;
  countries: Country[] | Option[];
  collectionDataType?: CollectionDataType;
  productType?: ProductType;
  productDataType?: ProductDataType;
  productGroups?: Option[];
  requireAllPgLoadedInCollections?: boolean;
}

export const getFilters = async ({
  clientId,
  countries,
  collectionDataType,
  productType,
  productDataType,
  productGroups,
  requireAllPgLoadedInCollections = true,
}: GetFiltersParams): Promise<MainFilters[]> => {
  try {
    const countryIds = countries
      .map((country) => {
        if ('value' in country) {
          return country.value.toUpperCase();
        } else {
          return country.id.toUpperCase();
        }
      })
      .join('&country=');

    const params = {
      clientId: clientId,
      country: countryIds,
      isUsingCollectionLiveData: collectionDataType === 'live',
      productType: productType ?? ProductType.PerformanceAnalyzer,
      productDataType: productDataType ?? ProductDataType.PerformanceAnalyzer,
      productGroups: productGroups
        ? productGroups.map((productGroup) => {
            return encodeURIComponent(productGroup.value);
          })
        : [],
      requireAllPgLoadedInCollections: requireAllPgLoadedInCollections,
    };
    const { data } = await axios.get<MainFilters[]>(constructFiltersUrl(), {
      params: params,
      paramsSerializer: paramsSerializer,
    });

    return data;
  } catch (err: any) {
    throw new Error(`An error has occurred: ${err}`);
  }
};

const constructFiltersUrl = () => {
  return `${environment.baseUrl}/opa/v2/filters`;
};
